import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, KeyRound, Send, ArrowLeft } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import api from '@/lib/api';

export default function AdminForgotPassword() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setDone(true);
      toast.success('Se l\'email è valida, riceverai a breve un link');
    } catch (err) {
      toast.error('Errore. Riprova.');
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-[color:var(--bg)] hero-overlay relative">
      <div className="w-full max-w-md rounded-2xl border border-[color:var(--border-c)] bg-[color:var(--surface)] p-7 relative z-10 shadow-[0_30px_80px_rgba(0,0,0,0.7)]">
        <div className="flex items-center gap-2 mb-2"><Sparkles className="w-4 h-4 text-[color:var(--gold)]"/><span className="text-xs uppercase tracking-[0.3em] text-[color:var(--gold)]">Reset password</span></div>
        <h1 className="font-heading text-3xl mb-1">Recupera l'accesso</h1>
        <p className="text-sm text-[color:var(--text-muted)] mb-6">Inserisci la tua email. Ti invieremo un link sicuro per reimpostare la password (valido 60 minuti).</p>
        {done ? (
          <div className="text-center py-6" data-testid="forgot-password-success">
            <KeyRound className="w-12 h-12 mx-auto text-[color:var(--gold)] mb-3"/>
            <p className="text-[color:var(--text)] mb-2">Controlla la tua casella email.</p>
            <p className="text-xs text-[color:var(--text-muted)]">Se non lo trovi entro qualche minuto, controlla anche lo spam.</p>
            <Link to="/admin/login" className="inline-block mt-4"><Button variant="outline" className="border-[color:var(--gold)] text-[color:var(--gold)]">Torna al login</Button></Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="forgot-password-form">
            <div>
              <Label className="text-xs uppercase tracking-wider text-[color:var(--text-subtle)]">Email</Label>
              <Input data-testid="forgot-password-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="tuanome@email.com" className="mt-1 bg-[color:var(--surface-2)] border-[color:var(--border-c)]"/>
            </div>
            <Button data-testid="forgot-password-submit" type="submit" disabled={busy} className="w-full bg-[color:var(--gold-strong)] hover:bg-[#C6A21A] text-black font-semibold"><Send className="w-4 h-4 mr-2"/>{busy ? 'Invio…' : 'Invia link reset'}</Button>
          </form>
        )}
        <div className="mt-6 pt-4 border-t border-[color:var(--border-c)] text-center">
          <Link to="/admin/login" className="text-xs text-[color:var(--text-subtle)] hover:text-[color:var(--gold)] inline-flex items-center gap-1"><ArrowLeft className="w-3 h-3"/>Login</Link>
        </div>
      </div>
    </div>
  );
}
